import helperMatomo from 'shared/mixins/helper-matomo';

const selector = '[data-js-call-me]';
const nyTel = function (el, app) {

    const $el = $(el);
    const $document = $(document);

    const mode = $el.attr('data-js-call-me-mode')
    const matomo = helperMatomo(app);

    const isQueue = mode === 'Queue'
    const isEmail = !isQueue;

    const init = function () {
        registerEvents();
    };

    const getForm = function (eltInForm) {
        return $(eltInForm).closest('[data-js-call-me]');
    }

    function buildFormData(formData, data, parentKey) {
        if (data === '' || data === null || data === undefined) {
            formData.append(parentKey, '');
        }
        else if (data instanceof Date || moment.isMoment(data)) {
            formData.append(parentKey, moment(data).format('YYYY-MM-DD HH:mm:ss'))
        }
        else if (data instanceof File) {
            formData.append(parentKey, data)
        }
        else if (typeof data === 'object') {
            Object.keys(data).forEach(key => {
                buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
            });
        }
        else {
            formData.append(parentKey, data)
        }
    }
 
    function jsonToFormData(data) {
        const formData = new FormData();
        if (data)
            buildFormData(formData, data);
        return formData;
    }

    function callApi({ path, httpMethod, params }) {

        const body = jsonToFormData(params)

        return window.fetch(path,
            {
                method: httpMethod || 'POST',
                redirect: 'manual',
                credentials: 'same-origin',
                body
            })
            .then(r => {
                return r.text()
                    .then(apiResultText => {
                        return JSON.parse(apiResultText)
                    });
            })
    }



    const registerEvents = function () {
        if (window["callMePopupEvents"] === undefined) {
            window["callMePopupEvents"] = true;
            app.on('popComplete', ({ $container }) => {
                const $form = $container.find('[data-js-call-me]')
                updateDates($form)
                phoneInp($form).val('');
            });
            if (isQueue) {
                $document.on('change', '[data-js-call-me-date]', function () {
                    updateTimes(getForm(this));
                });
            }
            $document.on('click', '[data-js-call-me-submit]', function (ev) {
                ev.preventDefault();
                submitForm(this, false);
            });
            if (isQueue) {
                $document.on('click', '[data-js-call-me-submit-asap]', function (ev) {
                    ev.preventDefault();
                    submitForm(this, true);
                });
                $document.on('click', '[data-js-call-me-update]', function (ev) {
                    ev.preventDefault();
                    updateDates(getForm(this))
                });
            }
            if (!isQueue) {
                $document.on('keyup', '[data-js-call-me-input]', function (ev) {
                    if (ev.keyCode == 13) {
                        submitForm(this, false);
                    }
                });
            }
        }

    };

    let possibleDates = []

    const createOption = (text, value, isSelected) => {
        var $o = $("<option />").attr("value", value);
        if (isSelected) {
            $o.attr("selected", "selected")
        }
        $o.text(text);
        return $o;
    }

    const phoneInp = $form => $form.find("[data-js-call-me-phone]");
    const firstNameInp = $form => $form.find("[data-js-call-me-first-name]");
    const lastNameInp = $form => $form.find("[data-js-call-me-last-name]");
    const dateSel = $form => $form.find("[data-js-call-me-date]");
    const timeSel = $form => $form.find("[data-js-call-me-time]");
    const noTimes = $form => $form.find("[data-js-call-me-no-times]");
    const alreadyInQueue = $form => $form.find("[data-js-call-me-error-already-in-queue]");
    const timeNotAvailable = $form => $form.find("[data-js-call-me-error-time-not-available]");
    const working = $form => $form.find("[data-js-call-me-working]");
    const complete = $form => $form.find("[data-js-call-me-complete]");
    const completeAsap = $form => $form.find("[data-js-call-me-complete-asap]");
    const form = $form => $form.find("[data-js-call-me-form]");
    const asap = $form => $form.find("[data-js-call-me-submit-asap]");

    const hide = (items) => {
        for (const $item of items) {
            $item.addClass("Ge-Hidden");
        }
    }

    const show = (items) => {
        for (const $item of items) {
            $item.removeClass("Ge-Hidden");
        }
    }

    const updateDates = $form => {

        stateWorking($form)

        return callApi({
            path: "/site-api/customer-service/possible-call-me-times",
            params: {
                schedule: 'CustomerService' + mode
            }
        })
            .then(({ result }) => {
                hide([working($form)]);
                possibleDates = result.dates

                if (possibleDates.length === 0) {
                    stateNoTimes($form)
                }
                else {

                    if( result.isAsapPossible ){
                        show( [asap($form)])
                    }
                    else {
                        hide( [asap($form)])
                    }

                    stateDefault($form)
                    const $date = dateSel($form)
                    $date.empty();

                    for (let i = 0; i < possibleDates.length; i++) {
                        const item = possibleDates[i];
                        createOption(item.text, item.date, i === 0).appendTo($date);
                    }

                    updateTimes($form)
                }

            });

    }

    const updateTimes = $form => {


        const currentDate = dateSel($form).val()
        const $time = timeSel($form)
        $time.empty()

        if (!currentDate) {
            return
        }

        const times = possibleDates.find(t => t.date === currentDate).times

        for (let i = 0; i < times.length; i++) {
            const item = times[i];
            createOption(item.text, item.time, i === 0).appendTo($time);
        }

    }

    const stateDefault = function ($form) {
        show([form($form)]);
    };

    const stateWorking = function ($form) {
        hide([form($form)])
        show([working($form)])
    };

    const stateNoTimes = function ($form) {
        hide([form($form)])
        show([noTimes($form)])
    };

    const stateComplete = function ($form, isAsap) {
        hide([form($form)])
        show([isAsap ? completeAsap($form) : complete($form)])
    };

    const submitForm = function (eltInForm, isAsap) {

        const $form = getForm(eltInForm);

        const $phone = phoneInp( $form );
        const phone = $phone.val();
        const phoneValid = $phone[0].checkValidity();
        $phone.attr('aria-invalid', !phoneValid);

        let fieldsValid = phoneValid;
        let firstName;
        let lastName;

        let requestedTime;

        if (isQueue) {
            requestedTime = timeSel($form).val();

            const $firstName = firstNameInp( $form );
            firstName = $firstName.val();
            const firstNameValid = $firstName[0].checkValidity()
            $firstName.attr('aria-invalid', !firstNameValid);

            const $lastName = lastNameInp( $form );
            lastName = $lastName.val();
            const lastNameValid = $lastName[0].checkValidity()
            $lastName.attr('aria-invalid', !lastNameValid);

            fieldsValid = fieldsValid && firstNameValid && lastNameValid;
        }
        else {
            requestedTime = $form.find('[data-js-call-me-fieldset-radio]:checked').val();
        }

        const timeValid = !!requestedTime;

        $form.find(".Ge-CallMe-ChooseTimeMessage").toggleClass("Ge-Hidden", timeValid);

        if (timeValid && fieldsValid) {

            stateWorking($form);

            callApi({
                path: "/site-api/customer-service/customer-service-call-me",
                params: {
                    mode,
                    phone,
                    firstName,
                    lastName,
                    requestedTime,
                    asap: !!isAsap
                }
            })
                .then(({ result }) => {
                    hide([working($form)]);

                    switch (result.status) {
                        case 'Ok':
                            if( window.useMatomo2023 ){
                                matomo.push( { event: "ringupp" } );
                            }
                            stateComplete($form, isAsap);
                            // ga
                            app.trigger('beacon', 'contact-callme,success');
                            break;

                        case 'TimeNotAvailable':
                            hide( [alreadyInQueue($form)] );
                            show( [timeNotAvailable($form)] );
                            updateDates($form);
                            break;

                            case 'AlreadyInQueue':
                                stateDefault($form);
                                hide( [timeNotAvailable($form)] );
                                show( [alreadyInQueue($form)] );
                                break;
    
    
                        case 'Failed':
                            alert('Vi kunde tyvärr inte boka denna tid.');
                            updateDates($form);
                            break;
                    }
                });
        }
    }

    return {
        init: init()
    };
};

nyTel.selector = selector;

export default nyTel;
